var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0016C060-1D6D-4E83-A6CE-8A93629FCFB4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-get-in-touch",
    transform: "translate(-711, -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size=24",
    transform: "translate(711, 520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.810036,19.2659615 L5.99439521,22.7732247 C5.77783345,22.8996906 5.56080827,22.9527585 5.34330474,22.9327273 C5.12577131,22.9125465 4.92885214,22.8392979 4.75253226,22.7128319 C4.57622734,22.586366 4.44017925,22.4210334 4.34435811,22.2169837 C4.24850707,22.0127845 4.23316971,21.7872087 4.29834602,21.5399572 L5.842068,14.9366696 L0.707788752,10.4922727 C0.516146465,10.3255947 0.39397077,10.1324576 0.341276616,9.91316019 C0.288582461,9.69371333 0.3024698,9.48039543 0.382953581,9.27350547 C0.463452311,9.06646603 0.5793944,8.89739627 0.730809745,8.76614672 C0.882210141,8.63474768 1.08918979,8.54909165 1.35173374,8.50873017 L8.12749943,7.91661231 L10.7577973,1.68128684 C10.8536184,1.44940266 10.9989198,1.27788132 11.1934023,1.16670786 C11.3878848,1.0555643 11.5934294,1 11.810036,1 C12.0264932,1 12.2320377,1.0555643 12.4266698,1.16670786 C12.6211523,1.27788132 12.7663041,1.44940266 12.8621253,1.68128684 L15.4924979,7.91661231 L22.2682935,8.50873017 C22.5307926,8.54909165 22.737832,8.63474768 22.8891128,8.76614672 C23.0405431,8.89739627 23.156545,9.06646603 23.236969,9.27350547 C23.3175425,9.48039543 23.3314448,9.69371333 23.2786759,9.91316019 C23.2260565,10.1324576 23.1037761,10.3255947 22.9121338,10.4922727 L17.7778546,14.9366696 L19.3216065,21.5399572 C19.3867828,21.7872087 19.3715351,22.0127845 19.2755645,22.2169837 C19.1797433,22.4210334 19.0437102,22.586366 18.8674651,22.7128319 C18.6910704,22.8392979 18.4941961,22.9125465 18.2766926,22.9327273 C18.059189,22.9527585 17.842134,22.8996906 17.6255274,22.7732247 L11.810036,19.2659615 Z",
    id: "Path",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarClosed);
export default __webpack_public_path__ + "static/media/star-closed.7c45191144caadfab301ad690bf18975.svg";
export { ForwardRef as ReactComponent };